import gsap from 'gsap';
export default ()=>{
    const productionLists = document.querySelectorAll('.production__list');
    productionLists.length> 0?handleItems():false;

    function handleItems(){
        productionLists.forEach(element => {
            gsap.to('.production__item', {
               
                opacity: 1,
                ease: 'power1.out',
                duration: 0.8,
                stagger:0.2,
            });
            gsap.to('.production__item', { y: 0, duration: 0.8, stagger: 0.2, ease: 'power3.out'});
        });
    }
}